import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Minha História: Marco Stefanini",
    correct: false,
  },
  {
    option: "b) Sonho Grande",
    correct: false,
  },
  {
    option: "c) O filho da Crise",
    correct: true,
  },
  {
    option: "d) Marco Stefanini e a transformação Digital",
    correct: false,
  },
  {
    option: "e) Uma Biografia da Transformação Digital",
    correct: false,
  },
];

export default function Question3(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question3: {
          title: "Qual o nome da biografia do fundador do Grupo Stefanini ?",
          option: option.option,
          correct: option.correct,
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t("Qual o nome da biografia do fundador do Grupo Stefanini ?")}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
